import Vue from 'vue';
import formatDate from './formatDate';

Vue.directive('format-date', formatDate);
